<template>
    <div class="container-fluid">
        <h5 class="mt-2">Edytuj Artykuł</h5>
        <div class="row mt-3">
            <div class="col-6 col-sm-6 col-md-6">
                <form @submit.prevent="submit" >
                    <div class="form-group" v-if="errors.length" >
                        <ul class="list-group">
                            <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
                        </ul>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Tytuł</label>
                        <input class="form-control" v-model="form.title"/>
                    </div>
                    <div class="form-group input-group-sm">
                        <div id="editor-container" ref="editor-container" >
                        </div>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Sortowanie</label>
                        <input class="form-control" type="number" v-model="form.customSortValue"/>
                    </div>
                    <input class="btn btn-success torre-btn btn-sm mr-2" type="submit" value="Zapisz">
                    <button class="btn btn-secondary btn-sm" @click.prevent="$router.go(-1)">Anuluj</button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import alertify from 'alertifyjs';
import un from 'underscore'
import Quill from "quill"
import ArticlesService from "@/components/articles/ArticlesService"

const articlesService = new ArticlesService()

export default {
    name: "ArticlesNew",
    data() {
        return {
            errors: [],
            quill: "",
            form: {
                articleId: this.$route.params.id,
                title: "",
                content: "",
                customSortValue: null
            }
        }
    },
    mounted() {
        this.loadArticle()
    },
    methods: {
        loadArticle() {
            articlesService.loadArticle(this.form, this.onLoadSuccess, this.onLoadError)
        },
        onLoadSuccess(data) {
            this.form = data
            this.initEditor()
        },
        onLoadError(err) {
            console.log(err)
            this.$router.push({name: 'articles'})
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie można pobrać wydatku.").delay(3);
        },
        submit() {
            this.clearErrors()
            this.form.content = this.quill.container.firstChild.innerHTML
            articlesService.editArticle(this.form, this.onEditSuccess, this.onEditError)
        },
        onEditSuccess(data) {
            this.$router.push({name: 'articles'})
            alertify.set('notifier','position', 'top-center');
            alertify.success("Artykuł został zapisany").delay(3);
        },
        onEditError(err) {
            console.log(err)
            this.errors = err
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie można zedytować artykułu.").delay(3);
        },
        clearErrors() {
            this.errors = []
        },
        initEditor: function() {
            this.noteEl = this.$refs['editor-container'];
            this.noteEl.innerHTML = this.form.content;
            this.quill = new Quill(this.noteEl, {
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],        
                        ['blockquote', 'code-block'],

                        [{ 'header': 1 }, { 'header': 2 }],               
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        [{ 'script': 'sub'}, { 'script': 'super' }],      
                        [{ 'indent': '-1'}, { 'indent': '+1' }],          
                        [{ 'direction': 'rtl' }],                         

                        [{ 'size': ['small', false, 'large', 'huge'] }],  
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'font': [] }],
                        [{ 'align': [] }],

                        ['clean'],
                        ['link', 'image']
                    ]
                },
                theme: 'snow',
                readOnly: !articlesService.isAdmin()
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/articles/ArticlesEdit.vue